import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DataTable, useLocale } from 'pe-core-frontend';
/**
 * Shared table for payment/payroll line items. Used by the Pending Payments tab and the
 * Payroll Details modal so both render identical columns and styling.
 */
export const PaymentItemsTable = ({ rows, loading, isParent, showCreated, autoHeight, fallbackCurrency, noDataText, }) => {
    const { formatCurrency, formatToLocalDatetime } = useLocale();
    const employerColumn = {
        field: 'clientName',
        headerName: 'Employer',
        flex: 0.25,
        minWidth: 140,
        sortable: true,
    };
    const createdColumn = {
        field: 'createdAt',
        headerName: 'Created',
        flex: 0.2,
        minWidth: 150,
        sortable: true,
        renderCell: ({ value }) => formatToLocalDatetime(value, { dateStyle: 'short', timeStyle: 'medium' }),
    };
    const columns = [
        ...(isParent ? [employerColumn] : []),
        ...(showCreated ? [createdColumn] : []),
        {
            field: 'employeeUniqueId',
            headerName: 'Employee ID',
            flex: 0.2,
            minWidth: 120,
            sortable: true,
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 0.2,
            minWidth: 140,
            sortable: false,
            renderCell: ({ row }) => (_jsxs("div", { children: [row.employeeFirstName, " ", row.employeeLastName] })),
        },
        {
            field: 'paymentRequestNum',
            headerName: 'Request #',
            flex: 0.2,
            minWidth: 120,
            sortable: true,
        },
        {
            field: 'paymentRequestItemDesc',
            headerName: 'Description',
            flex: 0.4,
            minWidth: 200,
            sortable: false,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 0.2,
            minWidth: 120,
            sortable: true,
            headerAlign: 'right',
            align: 'right',
            renderCell: ({ value, row }) => formatCurrency(value, row.currency || fallbackCurrency || 'USD', true),
        },
        {
            field: 'capYear',
            headerName: 'Cap Year',
            flex: 0.1,
            minWidth: 90,
            sortable: true,
        },
        {
            field: 'capSegment',
            headerName: 'Cap Segment',
            flex: 0.15,
            minWidth: 140,
            sortable: false,
        },
    ];
    return (_jsx(DataTable, { loading: loading, autoHeight: autoHeight, disableColumnMenu: true, disableRowSelectionOnClick: true, noDataText: noDataText, rows: rows, columns: columns }));
};
